export interface CustomerContextSource {
  title: string;
  url: string;
}

export interface CustomerContextPayload {
  force?: boolean;
  notes?: string;
}

export interface CustomerContextResponse {
  ok: boolean;
  context?: string;
  sources?: CustomerContextSource[];
  model?: string;
  generatedAt?: string;
  warnings?: string[];
  confidence?: number;
  error?: string;
}

export async function enrichCustomerContext(
  customerId: string,
  payload: CustomerContextPayload = {},
): Promise<CustomerContextResponse> {
  const response = await fetch(`/api/customers/${encodeURIComponent(customerId)}/enrich-context`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = (await response.json().catch(() => ({}))) as CustomerContextResponse;

  if (!response.ok) {
    const message = data?.error ?? `Failed to enrich context (HTTP ${response.status})`;
    throw new Error(message);
  }

  return data;
}